import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import convoStore from '@/store/convo/convo-store'
import statementStore from '@/store/statement/statement-store'

export default async function hideConvoStatements(context: BareActionContext<ConvoState, RootState>)
{
  let statements = statementStore.state.statements;
  let convo = convoStore.state.convo;

  for (let i=0; i<statements.length; i++) {
    if (convo.meta && convo.meta.statements.indexOf(statements[i]) >= 0) {
      statementStore.dispatchHideStatement(statements[i])
    }
  }

  return
}
